/* Sticky hoofdstuk-navigatie voor de online handleiding.
   - markeert het actieve hoofdstuk in de desktop-rail én de mobiele nav
   - werkt de huidige-hoofdstuk-tekst van de mobiele balk bij
   - sluit de mobiele <details> na een klik
   Degradeert netjes: zonder JS blijven de ankerlinks en <details> gewoon werken. */
(function () {
  var links = Array.prototype.slice.call(document.querySelectorAll('[data-manual-navlink]'));
  if (!links.length) return;

  var current = document.querySelector('[data-manual-current]');
  var mobilenav = document.querySelector('[data-manual-mobilenav]');

  // Verzamel de doel-secties (hoofdstuk-koppen) op anker-id.
  var targets = [];
  var seen = {};
  links.forEach(function (a) {
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    if (!id || seen[id]) return;
    var el = document.getElementById(id);
    if (el) {
      targets.push({ id: id, el: el, title: a.getAttribute('data-nav-title') || '' });
      seen[id] = true;
    }
  });
  if (!targets.length) return;

  function setActive(id, title) {
    links.forEach(function (a) {
      var match = (a.getAttribute('href') || '').replace(/^#/, '') === id;
      a.classList.toggle('is-active', match);
    });
    if (current && title) current.textContent = title;
  }

  var ticking = false;
  function update() {
    ticking = false;
    var line = window.innerHeight * 0.28; // trigger-lijn iets onder de bovenrand
    var active = targets[0];
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].el.getBoundingClientRect().top <= line) active = targets[i];
    }
    setActive(active.id, active.title);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  // Sluit de mobiele uitklap na een keuze.
  if (mobilenav) {
    links.forEach(function (a) {
      a.addEventListener('click', function () { mobilenav.open = false; });
    });
  }
})();
